// A clearable Lumen select for the client filters: the placeholder shows while nothing is picked.
// Shared by the doc-pabean table and the draft table (PR 7a).
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/lumen/select';
import { useLanguage } from '@contexts/LanguageContext';

const ALL = '__all';

/** A clearable Lumen select for the client filters: the placeholder shows while nothing is picked. */
export function FilterSelect({
  placeholder,
  value,
  onChange,
  options,
}: {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}) {
  const { t } = useLanguage();
  return (
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
      <SelectTrigger aria-label={placeholder} data-placeholder-text={placeholder} className="w-full">
        <SelectValue placeholder={placeholder}>
          {value ? undefined : <span className="text-fg-muted">{placeholder}</span>}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{t('docpabean.all')}</SelectItem>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
